export const actionsDispatchedSelector = state => state.actionsDispatched;